// PERSISTED
export const getInitializedValues = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('base')
}

export const getAndroidConfig = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('androidConfig')
}

export const getDebugger = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('debugger')
}

export const getCartItems = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('cartItems')
}

export const getCFDScreen = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('screen')
}

export const getTransactionResult = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('transactionResult')
}

export const getPaymentData = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('paymentData')
}

export const getOrderUpdate = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('orderUpdate')
}

export const getCartTotals = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('cartTotals')
}

export const getTips = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('tips')
}

export const getBalanceToBePaid = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('balanceToBePaid')
}

export const getCurrentCart = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('currentCart')
}

export const getCurrentOrder = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('currentOrder')
}

export const getCartTotalsUuid = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('cartTotalsUuid')
}

export const getCardError = (state) => {
  return state.PersistedVNCustomerFacingDisplay.get('cardError')
}

// NON PERSISTED

export const getCfdWebViewLoaded = (state) => {
  return state.VNCustomerFacingDisplay.get('isCfdWebViewLoaded')
}

export const getOrderDetails = (state) => {
  return state.VNCustomerFacingDisplay.get('orderDetails')
}

export const getSalesRequestExecution = (state) => {
  return state.VNCustomerFacingDisplay.get('executeSalesRequest')
}

export const getCanExecuteSalesRequest = (state) => {
  return state.VNCustomerFacingDisplay.get('canExecuteSalesRequest')
}

export const getPaymentProgress = (state) => {
  return state.VNCustomerFacingDisplay.get('paymentProgress')
}

export const getCurrentPaymentFlow = (state) => {
  return state.VNCustomerFacingDisplay.get('currentPaymentFlow')
}

export const getCurrentTransactionLifecycleMoment = (state) => {
  return state.VNCustomerFacingDisplay.get('currentTransactionLifecycle')
}

export const getCalculatedCurrentCartValues = (state) => {
  return state.VNCustomerFacingDisplay.get('calculatedCurrentCartValues')
}

export const getFormattedCartItems = (state) => {
  return state.VNCustomerFacingDisplay.get('formattedCart')
}

export const getPrintStatus = (state) => {
  return state.VNCustomerFacingDisplay.get('printStatus')
}

export const getAvailableBalance = (state) => {
  return state.VNCustomerFacingDisplay.get('availableBalance')
}

export const getIsPaired = (state) => {
  return state.VNCustomerFacingDisplay.get('isPaired')
}

export const getCurrentMessageUuid = (state) => {
  return state.VNCustomerFacingDisplay.get('currentMessageUuid')
}

export const getTempCFDScreen = (state) => {
  return state.VNCustomerFacingDisplay.get('tempCFDScreen')
}
